import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "water-detail-top-wrapper" }
const _hoisted_2 = { class: "station-selector-wrapper" }
const _hoisted_3 = { class: "right" }
const _hoisted_4 = { class: "water-detail-top" }

import { computed, onMounted, onUnmounted, watch, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import moment from 'moment'
import CurrentDataPanel from '@/components/water_detail/CurrentDataPanel.vue'
import DiagramPanel from '@/components/water_detail/DiagramPanel.vue'
import GraphPanel from '@/components/water_detail/GraphPanel.vue'
import StationSelector from '@/components/common/StationSelector.vue'
import ControllPanel from '@/components/common/ControllPanel.vue'
import { useWaterDetailStore } from '@/stores/waterDetailStore'
import { useGlobalStore } from '@/stores/globalStore'
import { useInitDataStore } from '@/stores/initDataStore'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const FETCH_INTERVAL = 60 * 1000 // 1分
const globalStore = useGlobalStore()
const initDataStore = useInitDataStore()
const route = useRoute()
const router = useRouter()
const waterDetailStore = useWaterDetailStore()
const stationId = computed(() => {
  return globalStore.currentStation?.stationId
})

// 指定された時間からresolutionに適した時間を返す
// half_day: 1時間単位
// ten_min: 10分単位
const getTime = (date: Date = new Date()) => {
  const min = resolution.value === 'half_day' ? 0 : Math.floor(date.getMinutes() / 10) * 10 // 分を10分単位に整形
  return moment(date).set('minutes', min).set('second', 0).toDate()
}

const resolution = ref<string>('ten_min')
const defaultDate = getTime()
const timer = ref<number>(0)
const currentDate = ref<Date>(defaultDate)

const fetch = () => {
  waterDetailStore.fetch(stationId.value as string, resolution.value, currentDate.value)
}

const attachCurrentStation = () => {
  const station = initDataStore.initData.stationList.find(station => station.stationId === route.params.stationId)
  const areaCode = station?.areaCode[0]

  if (!areaCode) {
    return
  }

  const area = initDataStore.areaList.find(area => area.id === areaCode)

  globalStore.currentArea = area
  globalStore.currentStation = station
}

const resolutions = [
  { label: '10分', value: 'ten_min' },
  { label: '1時間', value: 'half_day' },
]

const handleChangeDate = (date: Date) => {
  const format = 'YYYYMMDDHH'

  if (moment(date).format(format) === moment().format(format)) {
    globalStore.startAutoUpdate()
  } else {
    globalStore.stopAutoUpdate()
  }

  currentDate.value = getTime(date)
  fetch()
}

onMounted(() => {
  globalStore.startAutoUpdate()

  if (initDataStore.initData) {
    attachCurrentStation()
  }
  fetch()

  timer.value = setInterval(fetch, FETCH_INTERVAL)
})

onUnmounted(() => {
  clearInterval(timer.value)
})

watch(() => initDataStore.initData, attachCurrentStation)

watch(
  () => globalStore.currentStation,
  () => {
    const fieldId = globalStore.currentStation?.fieldId || []

    if (fieldId.includes('rainfall')) {
      router.push(`/weather_detail/${globalStore.currentStation?.stationId}`)

      return
    }

    fetch()
  }
)
watch(
  () => resolution.value,
  () => {
    currentDate.value = getTime()
    fetch()
  }
)

return (_ctx: any,_cache: any) => {
  const _component_UdcSelect = _resolveComponent("UdcSelect")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(StationSelector, { "station-type": "water" }),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(ControllPanel, {
          onChangeDate: handleChangeDate,
          "default-resolution": resolution.value,
          "default-date": _unref(defaultDate),
          "show-resolution": false,
          class: "flex-center hide-sp"
        }, null, 8, ["default-resolution", "default-date"]),
        _createVNode(_component_UdcSelect, {
          modelValue: resolution.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((resolution).value = $event)),
          options: resolutions,
          class: "hide-sp"
        }, null, 8, ["modelValue"])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(CurrentDataPanel, { resolution: resolution.value }, null, 8, ["resolution"]),
      _createVNode(DiagramPanel),
      _createVNode(GraphPanel, {
        resolution: resolution.value,
        date: currentDate.value,
        class: "hide-sp"
      }, null, 8, ["resolution", "date"])
    ])
  ]))
}
}

})